import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d8ae049e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-24 -md:pt-16" }
const _hoisted_2 = { class: "px-6 py-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title text-left pb-5" }, "Software Houses", -1))
const _hoisted_4 = { class: "flex h-full w-full flex-col items-center justify-start" }
const _hoisted_5 = { class: "grid grid-cols-12 gap-x-4 gap-y-2 -lg:flex -lg:flex-col" }
const _hoisted_6 = { class: "grid col-span-6 grid-cols-12 -lg:flex -lg:flex-col" }
const _hoisted_7 = { class: "col-span-4 grid grid-cols-12 w-full gap-4 -lg:flex -lg:flex-col" }
const _hoisted_8 = { class: "col-span-2 flex h-full w-full items-center justify-end -lg:h-16" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_10 = { class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_11 = { class: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" }
const _hoisted_12 = { class: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg" }
const _hoisted_13 = {
  key: 1,
  class: "shadow overflow-hidden flex border-b border-gray-200 bg-gray-50 sm:rounded-lg w-full h-60"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("embed", {
  width: "50",
  height: "50",
  src: "/colorful-loading.gif",
  class: "m-auto"
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-lg" }, "Nenhuma software house encontrada!", -1))
const _hoisted_17 = { class: "flex w-full mt-4" }
const _hoisted_18 = { class: "w-2/5 bg-white m-auto rounded-lg p-3 z-50" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " Para iniciar o processo de credenciamento, preencha os campos abaixo: ", -1))
const _hoisted_20 = {
  id: "email",
  class: "my-4 p-5 border-grey-300 border rounded-lg"
}
const _hoisted_21 = {
  key: 0,
  alt: "",
  src: "/full-logo-blue.png",
  width: "200",
  height: "50",
  class: "-lg:hidden mx-auto mb-6"
}
const _hoisted_22 = { class: "title" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = ["hidden"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Card = _resolveComponent("Card")!
  const _component_CustomInput = _resolveComponent("CustomInput")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Form, { class: "mt-1 !space-y-0" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_Input, {
                  modelValue: _ctx.searchSoftwareHouseText,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchSoftwareHouseText) = $event)),
                  type: "text",
                  label: "Pesquisar software house",
                  class: "col-span-12"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Input, {
                  modelValue: _ctx.startFilter,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startFilter) = $event)),
                  type: "date",
                  label: "Data inicial",
                  isIncorrect: !!_ctx.filterDateErrorMessage,
                  incorrectMessage: _ctx.filterDateErrorMessage,
                  class: "col-span-6"
                }, null, 8, ["modelValue", "isIncorrect", "incorrectMessage"]),
                _createVNode(_component_Input, {
                  modelValue: _ctx.endFilter,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endFilter) = $event)),
                  type: "date",
                  label: "Data final",
                  isIncorrect: !!_ctx.filterDateErrorMessage,
                  incorrectMessage: _ctx.filterDateErrorMessage,
                  class: "col-span-6"
                }, null, 8, ["modelValue", "isIncorrect", "incorrectMessage"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_PrimaryButton, {
                  label: "Filtrar",
                  iconCustomClass: "filter brightness-0 invert",
                  width: "w-full",
                  class: "col-span-12",
                  icon: _ctx.buttonIcons.search.icon,
                  onClick: _withModifiers(_ctx.searchSoftwareHouses, ["prevent"]),
                  type: "submit"
                }, null, 8, ["icon", "onClick"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      (_ctx.softwareHouses.length !== 0 && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(), _createBlock(_component_Table, {
                    columns: 
                  ['CNPJ', 'Razão Social', 'Data do Cadastro']
                ,
                    buttons: ['edit'],
                    itemsPerPage: 20,
                    "onUpdate:editTableItem": _ctx.handleEdit,
                    values: () => _ctx.softwareHouses.map(({ cnpj, razaoSocial, dataAtivacao }) => {
                  return {
                    cnpj: cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'),
                    razaoSocial,
                    dataCadastro: dataAtivacao ? _ctx.formatDate(dataAtivacao) : 'Pendente' ,
                  }
                }),
                    key: JSON.stringify(_ctx.softwareHouses),
                    tableId: "cnpj"
                  }, null, 8, ["onUpdate:editTableItem", "values"]))
                ])
              ])
            ])
          ]))
        : (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
          : (!_ctx.softwareHouses.length && !_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Card, {
                key: 2,
                class: "flex flex-col items-center justify-center h-60 border-b border-gray-200 bg-gray-50 sm:rounded-lg"
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_PrimaryButton, {
          class: "ml-auto",
          label: "Gerar Link",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.inviteModal = true, _ctx.linkModal = false))
        })
      ])
    ]),
    _createElementVNode("div", {
      id: "overlay",
      class: _normalizeClass(["fade-in", _ctx.inviteModal ? 'block' : 'hidden fade-out'])
    }, [
      _createElementVNode("div", {
        class: "h-screen flex overflow-y-scroll p-8",
        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.inviteModal = false), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            (!this.$store.state.isSidebarCollapsed)
              ? (_openBlock(), _createElementBlock("img", _hoisted_21))
              : _createCommentVNode("", true),
            _createVNode(_component_Form, {
              onSubmit: _withModifiers(_ctx.generateLink, ["prevent"]),
              class: "divide-transparent text-left"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CustomInput, {
                  label: "Razão Social",
                  name: "RazaoSocial",
                  validation: _ctx.formValidation.RazaoSocial,
                  value: _ctx.companyForm.RazaoSocial,
                  onChange: _ctx.changeField,
                  class: "col-span-12 sm:col-span-6 lg:col-span-4"
                }, null, 8, ["validation", "value", "onChange"]),
                _createVNode(_component_CustomInput, {
                  loading: false,
                  label: "CNPJ",
                  name: "CNPJ",
                  mask: "##.###.###/####-##",
                  autofocus: true,
                  disabled: false,
                  validation: _ctx.formValidation.CNPJ,
                  value: _ctx.companyForm.CNPJ,
                  onChange: _ctx.changeField,
                  class: "p-0 w-full"
                }, null, 8, ["validation", "value", "onChange"]),
                _createVNode(_component_CustomInput, {
                  loading: false,
                  label: "E-mail",
                  name: "Email",
                  disabled: false,
                  validation: _ctx.formValidation.Email,
                  value: _ctx.companyForm.Email,
                  onChange: _ctx.changeField,
                  class: "p-0 w-full"
                }, null, 8, ["validation", "value", "onChange"]),
                _createVNode(_component_CustomInput, {
                  label: "Tarifa padrão",
                  name: "MediatorFee",
                  type: "currency",
                  onChange: _ctx.changeField,
                  value: _ctx.companyForm.MediatorFee,
                  validation: _ctx.formValidation.MediatorFee,
                  class: "col-span-12 sm:col-span-6 lg:col-span"
                }, null, 8, ["onChange", "value", "validation"]),
                _createVNode(_component_PrimaryButton, {
                  label: "Salvar",
                  iconCustomClass: "text-white",
                  icon: _ctx.buttonIcons.save.icon,
                  disabled: !_ctx.buttonNewCompany,
                  class: "ml-auto",
                  type: "submit"
                }, null, 8, ["icon", "disabled"])
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      id: "overlay",
      class: _normalizeClass(_ctx.linkModal ? 'block' : 'hidden fade-out')
    }, [
      _createElementVNode("div", {
        class: "h-screen flex overflow-y-scroll p-8",
        onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.closeModal()), ["self"]))
      }, [
        _createVNode(_component_Card, {
          class: "w-4/5 bg-white m-auto rounded-lg p-3 z-50",
          width: "w-11/12 md:w-1/2 lg:w-1/3",
          orientation: "flex-col"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, _toDisplayString(!_ctx.error ? "Aqui está seu link para iniciar o cadastro no Tecnopay" : _ctx.error), 1),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_23, "Aqui está seu link para acessar o cadastro no Tecnopay."))
              : _createCommentVNode("", true),
            _createVNode(_component_Input, {
              modelValue: _ctx.createLink,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.createLink) = $event)),
              disabled: "",
              ref: "createLink",
              label: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_PrimaryButton, {
              class: "ml-auto",
              label: _ctx.copied,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.copyToClipboard()))
            }, null, 8, ["label"])
          ]),
          _: 1
        })
      ])
    ], 2),
    _createElementVNode("div", {
      id: "toast-block",
      hidden: _ctx.hidden,
      onHide: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
      onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.hide()), ["self"]))
    }, [
      _createVNode(_component_Toast, {
        label: _ctx.message,
        onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.hide()), ["self"])),
        onHide: _ctx.hide
      }, null, 8, ["label", "onHide"])
    ], 40, _hoisted_24)
  ]))
}